export const Environments = {
    PRODUCTION: "production",
    DR: "dr",
    STAGING: "staging",
    DEV: "dev",
    TEST: "test",
} as const;

export const EnvironmentTabs = {
    Servers:"Servers",
    VPCPeering :"VPC Peeering",
    PrivateLink:"Private Link"
}

export enum QuotationStatus  {
    Pending = "Pending",
    Active = "Active",
    Approve = "Approved",
    Reject = "Rejected"
}

export enum UpdatedBy{
    Sales = "Sales",
    Customer = "Customer",
    Accounts = "Accounts",
}

export const EnvironmentTabEnum = {
    SERVERS: "servers",
    PEERINGS: "vnet-peerings",
    PRIVATE_LINKS: "private-links",
    PUBLIC_IPS: "public_ips"
} as const;

export enum CheckBoxSelection {
    CLEAR,
    NOTCLEAR
}

export enum EnvironmentStatus {
    ACTIVE = "active",
    PENDING="pending",
    PROVISIONING="provisioning",
    PROVISIONING_FAILED="provisioning_failed",
    DELETING="deleting",
    DELETION_FAILED="deletion_failed"
}
